require('/ui/components/entitypicker/container/entitypickercontainer.module.scss.module.css');

export const addItemButton = "_add-item-button_i3v7v_1";
